import React, { useState } from "react";
import PortfolioData from "../../data/portfolio/HowData.json";
import PortfolioHowItem from "./PortfolioHowItem";

const alldata = PortfolioData;
const PortfolioHow = ({ Column }) => {
  const [getAllItems] = useState(alldata);
  return (
    <>
      <div className="row row--15">
        {getAllItems.map((item) => (
          <div key={item.id} className={Column}>
            <PortfolioHowItem portfolio={item} />
          </div>
        ))}
      </div>
    </>
  );
};

export default PortfolioHow;
